(function () {
  const observerOpts = { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.1 };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, observerOpts);

  const enhance = (root = document) => {
    // Tag all sections once with [data-reveal]
    root.querySelectorAll('.shopify-section:not([data-reveal])').forEach((sec) => {
      sec.setAttribute('data-reveal', '');
      observer.observe(sec);

      // Optional: stagger direct children for a nicer effect (uncomment to use)
      // sec.querySelectorAll(':scope > *').forEach((el, i) => {
      //   el.style.transitionDelay = `${Math.min(i * 60, 360)}ms`;
      // });
    });
  };

  document.addEventListener('DOMContentLoaded', () => enhance());

  // Re-apply in the Theme Editor when sections are reloaded/selected
  document.addEventListener('shopify:section:load', (e) => enhance(e.target));
  document.addEventListener('shopify:section:select', (e) => enhance(e.target));
})();